import React from 'react';
import { useSelector } from 'react-redux';
import UserDateFormat from '../../../../user-date-format/index';
import Global from '../../../../../store/global-selectors';

const PrintedDateColumn = ({ fulfillmentPlanSetId }) => {
  const fulfillmentPlanSet = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanSetById(state, {
      fulfillmentPlanSetId,
    }),
  );
  const printedDate = fulfillmentPlanSet?.printDateUtc || null;

  if (!printedDate) {
    return '';
  }

  return <UserDateFormat value={printedDate} />;
};

export default {
  id: 'printed-date',
  messageDescriptorKey: 'printedDate',
  nonsortable: true,
  width: 130,
  render: ({ fulfillmentPlanSetId }) => <PrintedDateColumn fulfillmentPlanSetId={fulfillmentPlanSetId} />,
};
